import { AlertTriangle } from "lucide-react";
import { useI18n } from "../lib/i18n";
import { Button } from "./ui/button";

// matches: [{ part, item }] ; choices: { [index]: "ignore" | "issue" }
export const WarehouseMatchPanel = ({ matches, choices, setChoices, onCancel, onContinue, busy }) => {
  const { t } = useI18n();
  return (
    <div className="rounded-lg border-2 border-amber-400 bg-amber-50 p-3 space-y-3" data-testid="warehouse-match-panel">
      <div className="flex items-center gap-2 font-bold text-amber-900"><AlertTriangle className="w-4 h-4" />{t("whMatchTitle")}</div>
      {matches.map((m, i) => (
        <div key={i} className="bg-white border rounded-md p-2 space-y-2" data-testid={`wh-match-${i}`}>
          <div className="text-sm">
            <b>{m.part.name}</b> <span className="font-mono text-xs" dir="ltr">#{m.part.part_number}</span> × {m.part.quantity}
            <div className="text-xs text-slate-600">{t("whInStock")}: <b>{m.item.name}</b> · {t("quantity")}: <b data-testid={`wh-match-stock-${i}`}>{m.item.quantity}</b>{m.item.supplier_name ? ` · ${m.item.supplier_name}` : ""}</div>
          </div>
          <div className="flex gap-2">
            {[["ignore", "whIgnore"], ["issue", "whIssueFromWh"]].map(([v, l]) => (
              <button type="button" key={v} data-testid={`wh-match-${v}-${i}`} onClick={() => setChoices({ ...choices, [i]: v })}
                className={`px-3 py-1 rounded-full text-xs font-bold border transition-colors ${(choices[i] || "ignore") === v ? "bg-[#3E3E40] text-white border-[#3E3E40]" : "bg-white hover:bg-slate-100"}`}>{t(l)}</button>
            ))}
          </div>
        </div>
      ))}
      <div className="flex justify-end gap-2">
        <Button type="button" variant="outline" onClick={onCancel}>{t("cancel")}</Button>
        <Button type="button" disabled={busy} data-testid="wh-match-continue" onClick={onContinue}>{t("whContinueSave")}</Button>
      </div>
    </div>
  );
};
